import { render, staticRenderFns } from "./ShopPlatforms.vue?vue&type=template&id=016cbcdb&scoped=true"
import script from "./ShopPlatforms.vue?vue&type=script&lang=ts"
export * from "./ShopPlatforms.vue?vue&type=script&lang=ts"
import style0 from "./ShopPlatforms.vue?vue&type=style&index=0&id=016cbcdb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016cbcdb",
  null
  
)

export default component.exports